import apiInstance from "../api";
import endPoints from "../endpoints";

export const saveRolloverInRequest = (payload) => {
  return apiInstance().post(
    `${endPoints.rollOver.saveRolloverInRequest}`,
    payload
  );
};

export const getRolloverInRequestDetailsByEmployeeId = (employeeId) => {
  return apiInstance().get(
    `${endPoints.rollOver.getRolloverInRequestDetailsByEmployeeId}/${employeeId}`
  );
};

export const deleteRolloverInRequestDetailsById = (employeeId) => {
  return apiInstance().get(
    `${endPoints.rollOver.deleteRolloverInRequestDetailsById}/${employeeId}`
  );
};

export const getRolloverInRequestDetailsById = (id) => {
  return apiInstance().get(
    `${endPoints.rollOver.getRolloverInRequestDetailsById}/${id}`
  );
};

export const saveRollOverDocuments = (payload) => {
  return apiInstance().post(endPoints.rollOver.saveRollOverDocuments, payload, {
    headers: { "content-type": "multipart/form-data" },
  });
};

export const approveOrRejectRolloverInRequest = (payload) => {
  return apiInstance().post(
    `${endPoints.rollOver.approveOrRejectRolloverInRequest}`,
    payload
  );
};
